var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSquareAnswer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 77,
    viewBox: "0 0 77 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 52,
    width: 25,
    height: 25,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    transform: "matrix(1 0 0 -1 52 51)",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    transform: "matrix(1 0 0 -1 26 25)",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    transform: "matrix(1 0 0 -1 52 25)",
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    transform: "matrix(1 0 0 -1 26 77)",
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    transform: "matrix(1 0 0 -1 52 77)",
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    y: 26,
    width: 25,
    height: 25,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareAnswer);
export default __webpack_public_path__ + "static/media/square-answer.1117126c63c7e216d513c8e4c0579bbf.svg";
export { ForwardRef as ReactComponent };